export default __webpack_public_path__ + "static/media/model_results.ec6ce541.png";